export const SET_STEP = 'SET_STEP';

export const setStep = step => ({ type: SET_STEP, step });

